import { createSlice } from "@reduxjs/toolkit";

const selectedShops = [];

const selectedShopsSlice = createSlice({
    name: "scorecard",
    initialState: {
        selectedShops,
    },
    reducers: {
        reSetSelectedShopsData(state,action){
            state.selectedShops = []
        },
        setSelectedShopsData(state, action) {
            state.selectedShops = action.payload;
        },
    },
});


export const {
    setSelectedShopsData,
    reSetSelectedShopsData
} = selectedShopsSlice.actions;

export default selectedShopsSlice.reducer;
